<template>
    <div>
        <div v-for="student in students" :key="student.id" class="px-6">
            <div class="font-bold">
                {{
                    $t('messages.good_morning', {
                        name: student.name_or_nickname,
                    })
                }}
            </div>
            <div class="flex space-x-2">
                <div>
                    <img
                        :src="student.avatar_or_profile_photo"
                        alt=""
                        class="relative z-30 inline-block h-16 w-16 rounded-full ring-2 ring-white"
                    />
                </div>
                <div>
                    <div v-if="student.pet" class="h-16 w-16">
                        <img :src="student.pet.image_path" alt="" class="object-contain" />
                    </div>
                </div>
            </div>

            <p class="mt-3">
                Moltes felicitats per haver acabat aquest curs. Has treballat molt dur i has aconseguit moltes coses. Al
                llarg d’aquest curs has entrat un total de
                <span class="font-semibold">{{ student.dashboard_visit_count }}</span>
                vegades i obert
                <span class="font-semibold">{{ student.open_chests_count }}</span>
                cofres.
            </p>

            <p class="mt-3">
                Has realitzat un total de
                <span class="font-semibold">{{ student.attempts_count }}</span>
                quizzes.
            </p>

            <p class="mt-3">
                Has aconseguit arribar al nivell
                <span class="font-semibold">{{ student.level }}</span> amb total de
                <span class="font-semibold font-mono tabular-nums">{{ student.total_xp.toLocaleString('ca') }}</span>
                punts d'experiència.
            </p>

            <p class="mt-3">
                Al llarg de tot el joc has aconseguit acumular un màxim de
                <span class="font-semibold font-mono tabular-nums">{{ student.coins_total.toLocaleString('ca') }}</span>
                monedes de les quals has gastat
                <span class="font-semibold font-mono tabular-nums">{{ student.coins_spent.toLocaleString('ca') }}</span
                >.
            </p>

            <p class="mt-3">
                Has participat
                <span class="font-semibold font-mono tabular-nums">{{ student.fetch_quest_actions_count }}</span>
                vegades en missions de recol·lecció i
                <span class="font-semibold font-mono tabular-nums">{{ student.battle_actions_count }}</span>
                vegades en esdeveniments d'acció.
            </p>

            <p class="mt-3">
                A més a més, has aconseguit diversos fets destacables recompensats amb les següents insignies.
            </p>

            <div>
                <div class="flex items-center space-x-4 lg:space-x-6">
                    <div class="inline-block" v-for="badge in student.badges" :key="badge.name">
                        <img
                            class="w-16 h-16 rounded-full lg:w-20 lg:h-20 bg-indigo-400"
                            :src="badge.image_path"
                            alt=""
                        />
                    </div>
                </div>
            </div>

            <div>
                <span>
                    {{ $tc('messages.card_collections', 2) }}
                </span>

                <div class="flex items-center space-x-4 lg:space-x-6">
                    <div
                        class="inline-block"
                        v-for="card_collection in student.card_collections_obtained"
                        :key="card_collection.id"
                    >
                        <div class="w-16 h-16 lg:w-20 lg:h-20 relative">
                            <img class="rounded-full bg-indigo-400" :src="card_collection.image_path" alt="" />
                            <BadgePill color="green" class="absolute bottom-0 right-0">
                                &times;{{ card_collection.max_level }}
                            </BadgePill>
                        </div>
                    </div>
                </div>
            </div>

            <div class="page_break" />
        </div>
    </div>
</template>

<script>
import BadgePill from '@/components/BadgePill.vue';

export default {
    components: {
        BadgePill,
    },
    name: 'Show',
    props: ['students', 'badge'],
};
</script>
<style scoped>
.page_break {
    page-break-before: always;
}
</style>
